// ========== TEST URL ==========
export const API_ROOT_TEST =
	'https://icomfort-back-prod-copy.bis-apps.com/b1s/v2/'
export const CUSTOM_API_ROOT_TEST =
	'https://icomfort-back-prod-copy.bis-apps.com/api/'

// ========== PROD URL ==========
// export const API_ROOT_TEST =
// 	'https://icomfort-new-back-prod.bis-apps.com/b1s/v2/'
// export const CUSTOM_API_ROOT_TEST =
// 	'https://icomfort-new-back-prod.bis-apps.com/api/'

export const API_ROOT_PROD =
	'https://icomfort-new-back-prod.bis-apps.com/b1s/v2/'
export const CUSTOM_API_ROOT_PROD =
	'https://icomfort-new-back-prod.bis-apps.com/api/'

// export const API_ROOT_PROD = 'https://icomfort-backend-prod.bis-pro.com/b1s/v2/'

// export const CUSTOM_API_ROOT_PROD =
// 	'https://icomfort-backend-prod.bis-pro.com/api/'

export const COMPANY_NAME = 'icomfort'
export const LOGS_BASE_URL_TEST = 'https://logs-backend-test.bis-pro.com/api'
export const LOGS_BASE_URL_PROD = 'https://logs-backend-prod.bis-pro.com/api'

export const API_PHOTO_UPLOAD_PROD =
	'https://icomfort-file-upload.bis-apps.com/api/'
export const API_PHOTO_UPLOAD_TEST =
	'https://icomfort-file-upload.bis-apps.com/api/'

// ========== CASHBACK (iComfort.ReferralBot) URL ==========
export const CASHBACK_API_ROOT = 'https://icmfrt.sony.com.uz/api/'
export const CASHBACK_WEB = 'https://icomfort-nasiya.vercel.app/'
export const CASHBACK_API_TOKEN =
	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5MDAwMDIiLCJuYW1laWQiOiI5MDAwMDIiLCJ1bmlxdWVfbmFtZSI6IkV4dGVybmFsIEFQSSAoQWRtaW4pIiwicm9sZSI6ImFkbWluIiwiZW1wbG95ZWVfY29kZSI6IkVYVC1BRE1JTiIsIm5iZiI6MTc4NzQwMTI2NiwiZXhwIjo0MTAyNDQ0ODAwLCJpYXQiOjE3ODc0MDEyNjYsImlzcyI6ImlDb21mb3J0LkFwaSIsImF1ZCI6ImlDb21mb3J0LkFkbWluUGFuZWwifQ.HWIfvE_xxo6_zF7lponk_9yMLRpLe9MWDv5LKvEwREg'

export const CASHBACK_COMPANY_DB = 'NEW_ICOMFORT2'


export const LINK_SECRET = 'icomfort-nasiya'
